export interface FeaturedBrand {
  id: number
  slug: string
  name: string
  logo: string | null
  href: string
}

export const FEATURED_BRAND_EVENT = 'hub-featured-brand'
export const FEATURED_BRAND_EVENTS = {
  impression: [`${FEATURED_BRAND_EVENT}--impression`],
  click: [`${FEATURED_BRAND_EVENT}--click`],
}

export type BrandCardSize = 'leading' | 'smaller'

// Called after hydration: a fresh, unbiased order for each visit, independent
// of the server cache. Keep every brand eligible for every position.
export const shuffleFeaturedBrands = <T>(brands: readonly T[]): T[] => {
  const shuffled = [...brands]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

export const featuredBrandTracking = (brand: FeaturedBrand, index: number) => ({
  'data-track': '',
  'data-track-impression': '',
  'data-event-name': FEATURED_BRAND_EVENT,
  'data-event-brand-id': brand.id,
  'data-event-brand-slug': brand.slug,
  'data-event-advertiser': brand.name,
  'data-event-card-size': index === 0 ? 'leading' : 'smaller',
  'data-event-position': index + 1,
  'data-event-origin': 'hearing-aids-hub',
  'data-event-url': brand.href,
})
